/**
 * The chapter title as a reader should see it.
 *
 * Nine of the older masterclasses carry a hard-coded ordinal in the title
 * itself: "00. What balance actually means for a shooter", "11. Caution
 * flags". Coleman's rule is no numbered chapters, and the number is already
 * said twice around it anyway, by the "Chapter 1" eyebrow and the "1 / 8" in
 * the header, so a third copy inside the sentence is noise that also happens
 * to be wrong whenever a chapter moves.
 *
 * Stripped at display time rather than edited out of the modules, for two
 * reasons: the copy in those files is Coleman's and should not be rewritten
 * by a formatting decision, and if he wants the numbers back it is this one
 * function rather than 25 edits.
 *
 * Deliberately narrow. Only a one or two digit ordinal followed by a dot and
 * a space at the very start, so a title that legitimately opens with a number
 * ("3v2 passing", "2 ways to read a gap", "1980s motion") is untouched.
 */
const ORDINAL = /^\d{1,2}\.\s+/;

export function chapterDisplayTitle(title) {
  return typeof title === "string" ? title.replace(ORDINAL, "") : title;
}
